// src/components/erp/security/LoginSigmaKey.jsx
import React, { useState } from 'react';
import './../../style/Vars.css';
import './../../style/ElementsStyle.css';
import './../../style/ContainersStyles.css';
import { isMobile, isTablet } from 'react-device-detect';
import bgLogin from './img/bglogin.png';
import userIcon from './img/usericon.png';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ENDPOINTS } from '../Seguridad/Utils/Endpoints';
import { ENDPOINTS as GENERAL_ENDPOINTS } from '../General/Utils/Endpoints';
import { API_BASE } from '../../api';
import { FaEye, FaEyeSlash, FaLock } from 'react-icons/fa';

import Header from './Header';
import Footer from './Footer';
import { setSessionUser } from '../../utils/SessionUser';
import { useLogos } from '../../context/LogoProvider';
import AvisosPrivacidadAceptar from '../General/Components/Catalogos/AvisosPrivacidad/AvisosPrivacidadAceptar';

// Helper para URL de imagen (mismo esquema que en modales)
const SERVER_URL = API_BASE.replace(/\/api\/?$/, '');

export default function LoginSigmaKey() {
  const navigate = useNavigate();

  const [nombreUsuario, setNombreUsuario] = useState('');
  const [contrasena, setContrasena] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { getSystemImageUrl, getSystemConfig, refreshResources } = useLogos();
  const background = getSystemImageUrl('LOGIN', bgLogin);

  const containerClass = isMobile || isTablet
    ? 'login-form-container login-form-container-mobile'
    : 'login-form-container';
  const cardClass = isMobile || isTablet
    ? 'login-form-card login-form-card-mobile'
    : 'login-form-card';
  const inputClass = isMobile || isTablet
    ? 'login-form-input login-form-input-mobile'
    : 'login-form-input';
  const buttonClass = isMobile || isTablet
    ? 'login-form-button login-form-button-mobile'
    : 'login-form-button';

  const containerStyle = {
    backgroundImage: `url(${background})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  };

  const [avisosPendientes, setAvisosPendientes] = useState([]);
  const [showAvisos, setShowAvisos] = useState(false);
  const [tempSession, setTempSession] = useState(null);

  const handleLogin = async () => {
    setError('');

    try {
      const response = await axios.post(ENDPOINTS.usuarios + '/validar', {
        nombreUsuario: nombreUsuario,
        contrasenaHASH: contrasena
      });

      let loginExitoso = false;
      let idUsuario = null;
      let nombreUsuarioResp = null;

      const data = response.data;

      if (typeof data === 'number' || typeof data === 'string') {
        loginExitoso = data > 0 || data !== -1;
        if (loginExitoso) {
          idUsuario = data;
          nombreUsuarioResp = nombreUsuario;
        }
      } else if (data && typeof data === 'object') {
        if ('exito' in data) {
          loginExitoso = !!data.exito;
          idUsuario = data.idUsuario ?? null;
          nombreUsuarioResp = data.nombreUsuario ?? nombreUsuario;
        } else {
          loginExitoso = true;
          idUsuario = data.idUsuario ?? null;
          nombreUsuarioResp = data.nombreUsuario ?? nombreUsuario;
        }
      }

      if (loginExitoso) {
        // 1. Obtener el timeout dinámico
        let minutosTimeout = 15;
        try {
          const timeoutRes = await axios.get(ENDPOINTS.configuracionTimeout(idUsuario || 0));
          minutosTimeout = parseFloat(timeoutRes.data);
        } catch (error) {
          console.warn('[Login] No se pudo obtener el timeout dinámico', error);
        }

        const sessionData = {
          idUsuario: idUsuario ?? 0,
          nombreUsuario: nombreUsuarioResp || nombreUsuario,
          minutosInactividad: minutosTimeout
        };

        // 2. Verificar Avisos de Privacidad PENDIENTES
        try {
          const resAvisos = await axios.get(GENERAL_ENDPOINTS.avisosPrivacidadPendientes(idUsuario));
          const list = resAvisos.data || [];
          if (list.length > 0) {
            setAvisosPendientes(list);
            setTempSession(sessionData);
            setShowAvisos(true);
            return; // Detenemos aquí para mostrar los avisos
          }
        } catch (error) {
          console.warn('[Login] Error al verificar avisos pendientes', error);
        }

        // Si no hay avisos, procedemos normal
        finalizarLogin(sessionData);
      } else {
        setError('Usuario o contraseña incorrectos');
      }
    } catch (err) {
      console.error(err);
      setError('Error al conectar con el servidor');
    }
  };

  const finalizarLogin = async (sessionData) => {
    setSessionUser(sessionData);
    // Actualizar recursos visuales para la empresa del usuario
    if (refreshResources) {
      await refreshResources();
    }
    navigate('/menu');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div className="page-container">
      {showAvisos && (
        <AvisosPrivacidadAceptar
          idUsuario={tempSession.idUsuario}
          avisos={avisosPendientes}
          onFinished={() => finalizarLogin(tempSession)}
        />
      )}
      <Header />

      <main className="page-main">
        <div className={containerClass} style={containerStyle}>
          <div className={cardClass} role="form" aria-label="Formulario de inicio de sesión">
            <img src={userIcon} alt="Icono de usuario" className="login-form-icon-img" />
            <h2 className="login-form-title">Iniciar Sesión</h2>

            <input
              type="text"
              placeholder="Nombre de Usuario"
              className={inputClass}
              value={nombreUsuario}
              onChange={(e) => setNombreUsuario(e.target.value)}
              onKeyDown={handleKeyDown}
              aria-label="Nombre de Usuario"
              autoComplete="username"
            />
            <div style={{ position: 'relative', width: '100%' }}>
              <input
                type={showPassword ? 'text' : 'password'}
                placeholder="Contraseña"
                className={inputClass}
                value={contrasena}
                onChange={(e) => setContrasena(e.target.value)}
                onKeyDown={handleKeyDown}
                aria-label="Contraseña"
                autoComplete="current-password"
                style={{ paddingRight: '2.5rem' }}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#666',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 4,
                  zIndex: 10,
                }}
                title={showPassword ? 'Ocultar contraseña' : 'Ver contraseña'}
              >
                {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
              </button>
            </div>

            <div className="login-form-options" style={{ justifyContent: 'center' }}>
              <a
                href="#"
                className="login-form-forgot"
                onClick={(e) => {
                  e.preventDefault();
                  navigate('/forgot-password');
                }}
              >
                Olvidé mi Contraseña
              </a>
            </div>

            <button className={buttonClass} onClick={handleLogin}>
              <FaLock />
              <span> Iniciar Sesión</span>
            </button>

            {error && <p style={{ color: 'red', marginTop: 10 }}>{error}</p>}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
